import { Button } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Modal from '~/components/Modal';
import { InstallmentSummaryStateType } from '~/modules/addListing/types';
import getInstallmentDetails from '~/modules/addListing/pages/PriceStep/utils/getInstallmentDetails';
import DurationDate from '~/components/DurationDate';

const InstallmentSummaryModal = ({
  isLoading,
  onSubmit,
  onClose,
  summaryState,
}: {
  isLoading: boolean;
  onClose: () => void;
  onSubmit: () => void;
  summaryState: InstallmentSummaryStateType | null;
}) => {
  const { t } = useTranslation('app');

  if (!summaryState) return null;

  const summary = getInstallmentDetails(summaryState);
  const priceValue = (value: number) => (
    <Trans
      i18nKey="priceValue"
      t={t}
      values={{
        value: value.toLocaleString(),
      }}
      components={{
        tag: <span>placeholder</span>,
      }}
    />
  );

  const summaryRows = [
    {
      label: t('salePrice'),
      value: priceValue(summary.totalPropertyPrice),
    },
    {
      label: t('totalRequiredDownPaymentFromBuyer'),
      value: priceValue(summary.totalRequiredPriceForBuyer),
    },
    {
      label: t('remainingAmount'),
      value: priceValue(summary.remainingAmount),
    },
    {
      label: t('installmentPeriod'),
      value: (
        <DurationDate
          days={Number(summaryState.duration)}
          classNames={{
            value: 'text-title-5 text-black',
            text: 'text-title-5 text-black',
          }}
          visibleParts={{ months: true, years: true }}
        />
      ),
    },
    {
      label: t('monthlyInstallment'),
      value: priceValue(Math.round(summary.monthlyInstallment)),
    },
  ];

  const Footer = () => (
    <div className="flex items-center gap-3x ">
      <Button
        size="medium"
        variant="primary"
        className="rounded-[26px] w-[207px]"
        onClick={onSubmit}
        isLoading={isLoading}
        disabled={isLoading}
      >
        {t('follow')}
      </Button>
      <Button
        size="medium"
        variant="secondary"
        className=" rounded-[26px] "
        onClick={onClose}
      >
        {t('edit')}
      </Button>
    </div>
  );

  return (
    <Modal
      modalKey="installmentSummaryModal"
      title={t('detailsSummaryTitle')}
      Footer={<Footer />}
      scrolled={true}
    >
      <div className="flex flex-col gap-3x w-full h-full">
        <p className="text-body-1 text-gray__dark_2">
          {t('reviewYourDataBeforeContinue')}
        </p>

        <div className="flex flex-col gap-1.5x">
          {summaryRows.map((item, index) => (
            <div
              key={item.label}
              className={`flex flex-col  gap-x ${
                index < summaryRows.length - 1
                  ? 'border-b border-gray pb-1.5x'
                  : ''
              }`}
            >
              <p className="text-body-2 text-gray__dark_1">{item.label}</p>
              <p className="text-title-5 text-black">{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default InstallmentSummaryModal;
